import { useState } from 'react'

const STATUS_REASON_PRESETS = {
  'Not Interested': ['Too expensive','Going with another broker','No longer requires cover','Could not get suitable cover','Not returning calls','Other'],
  'Under Referral': ['Referred to specialist broker','Referred to underwriter','Complex risk — escalated','Client requested referral','Other'],
}

export function StatusReasonModal({ status, onConfirm, onSkip, onCancel }) {
  const [reason, setReason] = useState('')
  const presets = STATUS_REASON_PRESETS[status] || []
  return (
    <div className="overlay" onClick={e => e.target===e.currentTarget && onCancel()}>
      <div className="reason-modal">
        <div className="modal-head">
          <div>
            <div className="modal-title">Reason for status change</div>
            <div style={{fontSize:12,color:'var(--muted)',marginTop:2}}>Moving to <strong>{status}</strong> — a reason helps with reporting</div>
          </div>
          <button className="modal-close" onClick={onCancel}>✕</button>
        </div>
        <div className="modal-body">
          <div style={{marginBottom:12}}>
            {presets.map(p=>(
              <button key={p} className={`reason-preset ${reason===p?'selected':''}`} onClick={()=>setReason(p)}>{reason===p?'✓ ':''}{p}</button>
            ))}
          </div>
          <div style={{marginBottom:14}}>
            <label className="form-label">Custom reason</label>
            <textarea className="form-input" rows={2} value={reason} onChange={e=>setReason(e.target.value)} placeholder="Or type a custom reason..." />
          </div>
          <div className="form-actions" style={{marginTop:0,paddingTop:0,border:'none'}}>
            <button className="btn btn-secondary" onClick={onSkip}>Skip</button>
            <button className="btn btn-primary" onClick={()=>onConfirm(reason)} disabled={!reason.trim()}>Save reason</button>
          </div>
        </div>
      </div>
    </div>
  )
}
